import React, { memo, useCallback, useState } from 'react';
import { Button } from 'js/components/common/Button';
import { Game as CommonGame } from 'js/components/common/Game';
import { useTranslations } from 'js/hooks/i18n';

import style from './index.scss';

export default memo(({ gameCodes, showDivider, showGameInfo, showFeatureIcons = true, Game = CommonGame }) => {
    const showPerPage = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const showOverall = showPerPage * currentPage;
    const t = useTranslations();

    const increasePageNumber = useCallback(() => {
        setCurrentPage((_currentPage) => _currentPage + 1);
    }, []);

    return (
        <div className={style.games}>
            <div className={style.simpleGrid}>
                {gameCodes
                    .slice(0, showOverall)
                    .map(code =>
                    <Game key={code}
                          code={code}
                          withFlexWidth={false}
                          showGameInfo={showGameInfo}
                          className={`${style.game} ${showDivider ? style.divider : ''}`}
                          showFeatureIcons={showFeatureIcons}
                    />
                )}
            </div>
            {
                showOverall >= gameCodes.length
                    ? null
                    : (
                        <div className={style.buttons}>
                            <Button isNew={true} onClick={increasePageNumber}>{t('playtech.mobile.system.showMore')}</Button>
                        </div>
                    )
            }
        </div>
    );
});
